<template>
  <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M28.903 14.073L15.0006 1.09766L1.09814 14.073"
      stroke="#040A34"
      stroke-width="2.19512"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M27.0468 12.3477V27.0468C27.0468 28.0707 26.217 28.9005 25.1931 28.9005H4.80288C3.77904 28.9005 2.94922 28.0707 2.94922 27.0468V12.3477"
      stroke="#040A34"
      stroke-width="2.19512"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M27.3755 12.75V28.5H2.62549V12.75L15.0005 1.125L27.3755 12.75ZM14.9995 12C14.4474 12.0001 13.9996 12.4479 13.9995 13V17H9.99951C9.44731 17 8.99964 17.4478 8.99951 18C8.99964 18.5522 9.44731 19 9.99951 19H13.9995V23C13.9995 23.5522 14.4473 23.9999 14.9995 24C15.5518 24 15.9995 23.5523 15.9995 23V19H19.9995L20.1021 18.9951C20.6061 18.9438 20.9994 18.5176 20.9995 18C20.9994 17.4824 20.6061 17.0562 20.1021 17.0049L19.9995 17H15.9995V13C15.9994 12.4478 15.5517 12 14.9995 12Z"
      fill="#040A34"
    />
  </svg>
</template>
